"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
require("./banner.css");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 * A pre-styled Banner that spans the full width of it's parent, and can (optionally) stick to the top of the page.
 */
var Banner = function Banner(_ref) {
  var containerClassName = _ref.containerClassName,
    contentClassName = _ref.contentClassName,
    globalNavPadding = _ref.globalNavPadding,
    leftContent = _ref.leftContent,
    leftContentClassName = _ref.leftContentClassName,
    rightContent = _ref.rightContent,
    isSticky = _ref.isSticky;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])('sb-banner', _defineProperty({
      'sb-banner--sticky': isSticky,
      'sb-banner--nav-padding': isSticky && globalNavPadding,
      'bg-houseGreen': !containerClassName
    }, containerClassName, Boolean(containerClassName)))
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])('flex items-center justify-between height-100', _defineProperty({
      'sb-global-gutters': !contentClassName
    }, contentClassName, Boolean(contentClassName)))
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])(_defineProperty({
      'color-textWhite text-xs text-upper text-bold': !leftContentClassName
    }, leftContentClassName, Boolean(leftContentClassName)))
  }, leftContent), rightContent));
};
Banner.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * This class is applied to the outmost containing `div` of the `Banner`.
   */
  containerClassName: _propTypes["default"].string,
  /**
   * This class is applied to the inner content of the `Banner`.
   */
  contentClassName: _propTypes["default"].string,
  /**
   * If both this prop, and `isSticky` are `true`, padding will be added to drop the top of the `Banner` beneath a global nav element.
   */
  globalNavPadding: _propTypes["default"].bool,
  /**
   * Content to render on the left side of the `Banner`. Has opinionated styling that can be overwritten with the `leftContentClassName` prop.
   */
  leftContent: _propTypes["default"].node,
  /**
   * This class is applied to the `div` that surrounds the left content. If true, this will overwrite the default styling.
   */
  leftContentClassName: _propTypes["default"].string,
  /**
   * Content to render on the right side of the `Banner`. Does not have opinionated styling.
   */
  rightContent: _propTypes["default"].node,
  /**
   * If true, `position: sticky` will be applied to the `Banner`.
   */
  isSticky: _propTypes["default"].bool
} : {};
Banner.defaultProps = {
  globalNavPadding: false,
  isSticky: false
};
Banner.displayName = 'Banner';
var _default = exports["default"] = Banner;